import React, { useState } from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '../../../config/base'; // Ensure this points to your API configuration

const ImageUpload = ({ sessionname }) => {
  const [loading, setLoading] = useState(false);

  const uploadImages = async (files) => {
    try {
      const formData = new FormData();
      files.forEach(file => formData.append('photos', file));

      const response = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data && response.data.files) {
        return response.data.files;
      } else {
        throw new Error('No URLs returned from upload API');
      }
    } catch (error) {
      console.error('Image upload error:', error);
      message.error('Image upload failed.');
      return []; 
    }
  };

  const handleCustomRequest = async ({ file, onSuccess, onError }) => {
    setLoading(true);
    try {
      const urls = await uploadImages([file]);

      if (urls.length > 0) {
        onSuccess({ status: 'done', urls });
        message.success('Images uploaded successfully!');
      } else {
        throw new Error('Failed to retrieve image URLs.');
      }
    } catch (error) {
      onError(error);
      message.error('Image upload failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <Upload
        multiple
        listType="picture-card"
        showUploadList={true}
        customRequest={handleCustomRequest}
      >
        <Button icon={<UploadOutlined />} loading={loading}>
          {loading ? 'Uploading...' : 'Upload Images'}
        </Button>
      </Upload>
    </div>
  );
};

export default ImageUpload;
